import React from "react";
import { ListGroup, Button } from "react-bootstrap";

const AreaItem = ({ area, onDelete }) => {
  return (
    <ListGroup.Item className="d-flex justify-content-between align-items-center">
      <div>
        <strong>{area.name}</strong> — {area?.city?.city}
      </div>
      <i
        onClick={onDelete}
        style={{ cursor: "pointer" }}
        className="fas fa-trash text-danger border border-danger rounded-1 p-2"
      ></i>
    </ListGroup.Item>
  );
};

export default AreaItem;
